import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useRouterProps } from '../hooks/useRouterProps';

/**
 * SSO authentication route guard
 * Handles sentral and schoolBytes SSO authentication flows
 */
const SSORoute = ({
    children,
    render,
    ssoType = 'sentral', // 'sentral' | 'schoolBytes'
    redirectTo,
    ...props
}) => {
    const location = useLocation();
    const auth = useAuth();
    const routerProps = useRouterProps();

    // If authenticated, allow access
    if (auth.isAuthenticated) {
        return render ? render({ ...props, ...routerProps }) : children;
    }

    // Not authenticated, redirect to SSO login
    const authMethod = ssoType === 'schoolBytes' ? 'schoolBytes_sso' : 'sentral_sso';
    const loginPath = `/?redirectUri=${encodeURIComponent(
        location.pathname + location.search
    )}&auth_method=${authMethod}`;

    return <Navigate to={loginPath} replace />;
};

export default SSORoute;
